import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import CourseSettingForm from './CourseSettingForm';
import useDemoActionGate from '../hooks/useDemoActionGate';
import DemoLockedDialog from '../ui/DemoLockedDialog';

/** Legacy full-page route for course settings (e.g. deep links from CourseDetail). */
const CourseSetting = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { courseDetails } = location.state || {};
  const [missingDetailsAlert, setMissingDetailsAlert] = useState(!courseDetails);
  const { isLocked, lockedDialogOpen, setLockedDialogOpen } = useDemoActionGate();

  const handleDismiss = () => {
    navigate('/Portal/Instructor/Course');
  };

  const handleCloseMissingDetailsAlert = () => {
    setMissingDetailsAlert(false);
    handleDismiss();
  };

  if (!courseDetails) {
    return (
      <Dialog open={missingDetailsAlert} onClose={handleCloseMissingDetailsAlert}>
        <DialogTitle>Missing details</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Course details are missing. Please go back and select a course.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMissingDetailsAlert} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          maxWidth: '680px',
          margin: '24px auto',
          background: 'white',
          padding: '24px',
          borderRadius: '16px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
        }}
      >
        <CourseSettingForm
          key={courseDetails.courseId}
          courseDetails={courseDetails}
          onDismiss={handleDismiss}
          saveDisabled={isLocked('action.course.settings.save')}
        />
      </div>
      <DemoLockedDialog
        open={lockedDialogOpen}
        onClose={() => setLockedDialogOpen(false)}
      />
    </div>
  );
};

export default CourseSetting;
